import React, {useState} from 'react';

import {AutoHeightTitleInput} from 'app/components/general/AutoHeightTitleInput';

interface Props
  extends Pick<
    React.HTMLProps<HTMLTextAreaElement>,
    'placeholder' | 'onBlur' | 'onKeyPress' | 'className'
  > {
  defaultValue: string;
}

export const ProcedureStepTitleInput = ({
  defaultValue,
  onBlur,
  onKeyPress,
  placeholder,
  className,
}: Props) => {
  const [text, setText] = useState<string>(defaultValue);

  return (
    <AutoHeightTitleInput
      className={className}
      onChange={setText}
      value={text}
      style={textAreaStyles}
      onBlur={onBlur}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
    />
  );
};

const textAreaStyles = {
  paddingRight: '2.6rem',
};
